import { ParallaxProvider } from "react-scroll-parallax";
import HomeHero from "./HomeHero";
import HomeWhoWeAre from "./HomeWhoWeAre";
import HomeWillInfo from "./HomeWillInfo";
import HomeWillInfo2 from "./HomeWillInfo2";

const Home = () => (
	<ParallaxProvider>
		<div className="w-screen mb-28">
			<HomeHero />
			<HomeWillInfo />
			<HomeWillInfo2 />
			<HomeWhoWeAre />
		</div>
	</ParallaxProvider>
);

export default Home;
